import { useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";
import { fetchPublicationsContent } from "../APIClient/apiClient";

// Publications content hook
export function usePublicationsContent() {
  const { currentLanguage } = useTranslation();
  const [content, setContent] = useState({
    title: "",
    description: "",
    publications: [],
    headerTexts: [],
    metaTitle: "",
  });

  useEffect(() => {
    let isActive = true;

    setContent({
      title: "",
      description: "",
      publications: [],
      headerTexts: [],
      metaTitle: "",
    });

    fetchPublicationsContent(currentLanguage).then((data) => {
      if (!isActive) {
        return;
      }
      if (data) {
        setContent({
          title: data.title || "",
          description: data.description || "",
          publications: Array.isArray(data.publications) ? data.publications : [],
          headerTexts: Array.isArray(data.headerTexts) ? data.headerTexts : [],
          metaTitle: data.metaTitle || "",
        });
      }
    });

    return () => {
      isActive = false;
    };
  }, [currentLanguage]);

  return content;
}
